import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSection from "../components/head-section-two";
const FaQs = () =>{
    document.body.style.backgroundColor = "white"
    return (
        <div>
            <Header />
               <HeaderSection 
               title="FaQs" 
               smallTitle="Frequently Asked Questions /" 
               usmallTitle="1"
               />
               <section id="section_shop">
                   <div>
                       <p id="policy_header">1) Abourt Privacy Policy ?</p>
                        <p>
                        This Privacy Policy informs you of our policies regarding the collection, use and disclosure of your Personal Information when using our Service. Your information will not be shared or used by anyone except as described in this Privacy Policy.
                        We may use your Personal Information in order for you to use the Service and in order to make improvements from time to time. By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy constitutes an integral part of our Terms of Service (the “Terms of Service”). Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy shall have the same meanings as assigned to them in our Terms of Service, accessible at https://smartshoper.com.
                        </p>
                   </div>
               </section>
            <Footer />
        </div>
    )
}
export default FaQs;
